import { TSegmentedControlOption } from "@/components/elements/SegmentedControl";

export const ORGANIZATION_DETAIL_TAB_KEYS = {
  BASIC: "basic",
  USERS: "users",
  AUDIT: "audit",
} as const;

export const ORGANIZATION_DETAIL_TAB_OPTIONS = [
  { label: "基本契約情報", value: ORGANIZATION_DETAIL_TAB_KEYS.BASIC },
  { label: "ユーザー一覧", value: ORGANIZATION_DETAIL_TAB_KEYS.USERS },
];

export const CONTRACT_FILTER_KEYS = {
  DURING_CONTRACT_AND_TRIAL: "during_contract_and_trial",
  CANCEL: "cancel",
  ALL: "all",
};

export const CONTRACT_FILTER_OPTIONS: TSegmentedControlOption[] = [
  { label: "契約またはトライアル中", value: CONTRACT_FILTER_KEYS.DURING_CONTRACT_AND_TRIAL },
  { label: "解約済み", value: CONTRACT_FILTER_KEYS.CANCEL },
  { label: "すべて表示", value: CONTRACT_FILTER_KEYS.ALL },
];

export const USER_TYPE_KEYS = {
  ORGANIZATION: "organization",
  ADMIN: "admin",
} as const;

export const USER_TYPE_OPTIONS: TSegmentedControlOption[] = [
  { label: "組織ユーザー", value: USER_TYPE_KEYS.ORGANIZATION },
  { label: "いろはな管理ユーザー", value: USER_TYPE_KEYS.ADMIN },
];
